const PEDAGOGY_SYSTEM_TIME_ZONE = 'Europe/Moscow'

export function formatPedagogySystemTimestamp(value: string | null | undefined, withYear = true): string {
  if (!value) return '—'
  const date = new Date(value)
  if (Number.isNaN(date.getTime())) return value

  return `${new Intl.DateTimeFormat('ru-RU', {
    day: '2-digit',
    month: '2-digit',
    ...(withYear ? { year: 'numeric' as const } : {}),
    hour: '2-digit',
    minute: '2-digit',
    timeZone: PEDAGOGY_SYSTEM_TIME_ZONE,
  }).format(date)} МСК`
}
